import React from "react";

function AddIncidentReport({ contactID }) {
  const add = () => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=10124&extraqs=%3f_CreateFromId%3d" +
      contactID +
      "%26_CreateFromType%3d2%26etc%3d10124&histKey=457048345&newWindow=true&pagetype=entityrecord&navbar=off";
    window.open(url, "incidentReport");
  };
  return (
    <button className="me-1 btn bg-safy3-1 text-white" onClick={add}>
      <i className={"fas fa-plus-circle me-1 text-white"} />
      Incident Report
    </button>
  );
}

export default AddIncidentReport;
